import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAnalogueComponent } from './simple-icons-analogue.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAnalogueComponent ],
    exports:      [ SimpleIconsAnalogueComponent ],
    bootstrap:    []
})
export class SimpleIconsAnalogueModule {}
